import { render, staticRenderFns } from "./danger_card.vue?vue&type=template&id=0d12398a&scoped=true"
import script from "./danger_card.vue?vue&type=script&lang=js"
export * from "./danger_card.vue?vue&type=script&lang=js"
import style0 from "./danger_card.vue?vue&type=style&index=0&id=0d12398a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12398a",
  null
  
)

export default component.exports